<template>
  <div class="published-items-container">
    <LoadingSpinner position="absolute" v-if="isFetchingActivityPage" />
    <div class="published-items-content" v-else>
      <div class="change-state-page-content">
        <SButtonMaterial
          class="select-state-btn"
          :class="[{ 'select-state-btn-active': state === 'showMyPosts' }]"
          buttonType="button"
          textColor="tertiary"
          materialClass="dense"
          type="primary"
          text="Item posts"
          @button="changeState('showMyPosts')"
        />
        <SButtonMaterial
          class="select-state-btn ml-3"
          :class="[
            { 'select-state-btn-active': state === 'showMyRequests' },
          ]"
          buttonType="button"
          textColor="tertiary"
          materialClass="dense"
          type="primary"
          text="Transactions"
          dataCy="incomingRequests"
          @button="changeState('showMyRequests')"
        />
      </div>
      <SFilterBar
        id="filter-bar-activity"
        @requestSearch="makeRequestSearch"
        @postSearch="makePostSearch"
        @clearFilter="clearFilter"
        @removeFilter="removeFilter"
        :options="[optionsPosts, optionsRequests]"
        :choice="choice"
        :selectedFilters="selectedFilters"
        :startWith="startOption"
        selectName="-- Show all --"
        outsideLabel="Trade State"
        ref="filterbar"
        :isItemActivity="true"
        :showMyPosts="this.state === 'showMyPosts'"
      />
      <ActivityPostsList
        :activities="filteredResults"
        @updateItemStatus="itemUpdatedStatus = true"
      />
      <SNewSystemMessageActivityPage
        v-if="showEmptyMessage"
        :inRequestsTab="inRequestsTab"
      />
    </div>
    <div class="invite-friends-cta">
      <ReferFriendsCTA />
    </div>
  </div>
</template>

<script>
import SFilterBar from "@/components/molecules/SFilterBar";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import itemType from "@/enum/item-type";
import requestSituation from "@/enum/request-situation";
import itemStatus from "@/enum/item-status";
import ActivityPostsList from "@/components/organisms/ActivityPostsList";
import uniqid from "uniqid";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import SNewSystemMessageActivityPage from "@/components/organisms/SNewSystemMessageActivityPage.vue";
import ReferFriendsCTA from "@/material-components/atoms/ReferFriendsCTA.vue";

export default {
  name: "PublishedItems",
  mixins: [ItemHelperVue],
  components: {
    SFilterBar,
    ActivityPostsList,
    SButtonMaterial,
    LoadingSpinner,
    SNewSystemMessageActivityPage,
    ReferFriendsCTA
},
  data() {
    return {
      itemUpdatedStatus: false,
      state: "showMyPosts",
      filter: {
        options: [],
        optionsPost: [],
        optionsRequest: [],
      },
      optionsPosts: [
        { label: "Offered", value: itemType.GIVE, dataCy: "giveFilter" },
        { label: "Requested", value: itemType.RECEIVE, dataCy: "receiveFilter" },
      ],
      optionsRequests: [
        {
          label: "Waiting response",
          value: requestSituation.OPEN,
          dataCy: "waitingFilter",
        },
        {
          label: "Accepted",
          value: requestSituation.ACCEPTED,
          dataCy: "acceptedFilter",
        },
        {
          label: "Declined",
          value: requestSituation.REJECTED,
          dataCy: "declinedFilter",
        },
        {
          label: "Completed",
          value: "completed",
          dataCy: "completedFilter",
        },
      ],
      choice: {
        options: [],
        optionsPost: [],
        optionsRequest: [],
      },
      startOption: null,
    };
  },
  methods: {
    changeState(state) {
      if (state === this.state) {
        return;
      }
      this.filter.optionsPost = [];
      this.filter.optionsRequest = [];
      this.state = state;
    },
    makePostSearch(value) {
      this.filter.optionsPost = [...value.optionsPost];
    },
    makeRequestSearch(value) {
      this.filter.optionsRequest = [...value.optionsRequest];
    },
    clearFilter() {
      this.choice = {
        options: [],
        optionsPost: [],
        optionsRequest: []
      };
      this.filter = {
        options: [],
        optionsPost: [],
        optionsRequest: [],
      };
    },
    removeFilter({ value,  dataCy }) {
      const secondToRemove = value === 1 ? 3 : value === 2 ? 4 : 0
      if (dataCy === 'receiveFilter' || dataCy === 'giveFilter') {
        this.choice.optionsPost = this.choice.optionsPost.filter((filter) => {
        return filter !== value && filter !== secondToRemove;
      });
      } else {
        this.choice.optionsRequest = this.choice.optionsRequest.filter((filter) => {
          return filter !== value;
        });
      }
    },
    setLessItemDate(item) {
      if (item.requests.length) {
        let date;
        const updatedItem = new Date(item.updatedAt);
        const updatedActivity = new Date(item.requests[0].changeSituationAt);
        const activityDate = new Date(this.getLastItemTimeStamp(item.requests[0]));

        if (updatedItem > updatedActivity && updatedItem > activityDate) {
          date = updatedItem;
        } else if (
          updatedActivity &&
          updatedActivity > activityDate
        ) {
          date = new Date(updatedActivity);
        } else {
          date = new Date(activityDate);
        }
        return date;
      }
      return new Date(this.getLastItemTimeStamp(item)) || new Date();
    },
    lessItem(a, b) {
      let dateA = new Date(this.getLastItemTimeStamp(a)) || new Date();
      let dateB = new Date(this.getLastItemTimeStamp(b)) || new Date();
      let updatedActivity = new Date(a.changeSituationAt);
      let updatedActivityAux = new Date(b.changeSituationAt);

      if (a.item) {
        if (updatedActivity && updatedActivity >= dateA) dateA = new Date(updatedActivity);
      } else {
        dateA = this.setLessItemDate(a);
      }

      if (b.item) {
        if (updatedActivityAux && updatedActivityAux >= dateB) dateB = new Date(updatedActivityAux);
      } else {
        dateB = this.setLessItemDate(b)
      }
      return dateB - dateA;
    },
    filterCompletedStatus(result, merged) {
      if (this.filter.options.includes("completed")) {
        let req = [];
        req = merged.filter((request) => {
          if (request.status) {
            return (
              request.status === itemStatus.RECEIVED ||
              request.status === itemStatus.NOT_RECEIVED ||
              request.status === itemStatus.NOT_SENT
            );
          }
          return (
            request.item &&
            (request.item.status === itemStatus.RECEIVED ||
              request.item.status === itemStatus.NOT_RECEIVED ||
              request.item.status === itemStatus.NOT_SENT)
          );
        });
        return [...req];
      }
      return result
    },
  },
  watch: {
    $route(to, from) {
      if (to.query !== from.params) {
        if (
          this.$route.query.filter &&
          this.$route.query.filter === "incoming"
        ) {
          this.startOption = "incoming";
        }
      }
    },
    filteredResults(newValue) {
      if (newValue) {
        if (!this.itemUpdatedStatus) {
          this.setFetchingActivityPage(true);
          setTimeout(() => {
            this.setFetchingActivityPage(false);
          }, 1001);
        }
        this.itemUpdatedStatus = false;
      }
    },
    'filter.optionsPost': function (newValue) {
      if (newValue.includes(1) && !newValue.includes(3)) this.filter.optionsPost.push(3)
      if (newValue.includes(2) && !newValue.includes(4)) this.filter.optionsPost.push(4)

      if (newValue.includes(3) && !newValue.includes(1)) this.filter.optionsPost.splice(this.filter.optionsPost.indexOf(3), 1)
      if (newValue.includes(4) && !newValue.includes(2)) this.filter.optionsPost.splice(this.filter.optionsPost.indexOf(4), 1)

    },
  },
  computed: {
    showEmptyMessage() {
      return !this.filteredResults || this.filteredResults.length === 0;
    },
    inRequestsTab() {
      return this.state === "showMyRequests";
    },
    selectedFilters() {
      let filters = [];
      if (this.state === "showMyPosts") {
        this.optionsPosts.forEach((filter) => {
          if (this.choice.optionsPost.includes(filter.value) && filter.value !== "")
            filters.push(filter);
        });
      } else if (this.state === "showMyRequests") {
        this.optionsRequests.forEach((filter) => {
          if (this.choice.optionsRequest.includes(filter.value) && filter.value !== "")
            filters.push(filter);
        });
        this.optionsPosts.forEach((filter) => {
          if (this.choice.optionsPost.includes(filter.value) && filter.value !== "")
            filters.push(filter);
        });
      }
      return filters;
    },
    filteredPostsResults() {
      let merged = [];


        if (this.userInventoryWithRequests.length > 0) {
          merged = merged.concat([...this.userInventoryWithRequests]);
        }


      let result = [];
      let feedType;

      feedType = this.state === "showMyRequests" ? "requests" : "posts";

        let req = [];
        req = merged.filter((element) => {
          return this.filter.optionsPost.includes(
            element.item ? element.item.type : element.type
          );
        });
        result = [...req];

      if (this.filter.optionsPost.length === 0) {
        result = merged;
      }
      result = result.map((element) => {
        return {
          ...element,
          uId: uniqid(),
          feedType: feedType,
        };
      });

      return result.sort(this.lessItem);
    },

    filteredRequestsResults() {
      let merged = [];
      const filteredPosts = this.filteredPostsResults

        if (this.myRequestsMade.length > 0) {
          merged = [...this.myRequestsMade];
        }
        if (this.userInventoryWithRequests.length > 0) {
          let req = filteredPosts.filter((item) => {
            return item.requests.find(
              (element) => element.situation === requestSituation.ACCEPTED
            );
          });
          merged = merged.concat([...req]);
        }

      let result = [];
      let feedType;

      feedType = this.state === "showMyRequests" ? "requests" : "posts";
        let req = [];
        req = merged.filter((request) => {
          return this.filter.optionsRequest.includes(request.situation);
        });
        result = [...req];

        if (this.filter.optionsRequest.includes("completed")) {
          let req = [];
          req = merged.filter((request) => {
            if (request.status) {
              return (
                (
                request.status === itemStatus.RECEIVED ||
                request.status === itemStatus.NOT_RECEIVED ||
                request.status === itemStatus.NOT_SENT
              ) || this.filter.optionsRequest.includes(request.situation)
              );
            }
            return (
              request.item &&
              (
                (request.item.status === itemStatus.RECEIVED ||
                request.item.status === itemStatus.NOT_RECEIVED ||
                request.item.status === itemStatus.NOT_SENT)
                || this.filter.optionsRequest.includes(request.situation)
              )
            );
          });
          result = [...req];
        }
      if (this.filter.optionsRequest.length === 0) {
        result = merged;
      }
      result = result.map((element) => {
        return {
          ...element,
          uId: uniqid(),
          feedType: feedType,
        };
      });

      if (this.filter.optionsPost.length > 0) {
        result = result.filter((element) => {
          return this.filter.optionsPost.includes(
            element.item ? element.item.type : element.type
          );
        })
      }

      return result.sort(this.lessItem);
    },

    filteredResults() {
      if (this.state === "showMyPosts") return this.filteredPostsResults;
      return this.filteredRequestsResults
    },

  },
  mounted() {
    if (this.$route.query.filter && this.$route.query.filter === "incoming") {
      this.startOption = "incoming";
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.filterbar.destroy();
    next();
  },
  unmounted() {
    this.style.remove();
  },
};
</script>

<style lang="scss">
.md-select-menu {
  width: 190px !important;
}
.select-component {
  width: 190px;
}
#filter-bar-activity .ui-block-title {
  margin-left: -1.5rem !important;
}
#filter-bar-activity .material-select {
  min-width: 180px;
}

.change-state-page-content .select-state-btn {
  color: $dark !important;
  background-color: transparent !important;
}

.change-state-page-content button .md-ripple {
  padding: 0 !important
}

.change-state-page-content .select-state-btn-active {
  color: $tertiary !important;
  font-weight: 700 !important;
}
.publish-content {
  overflow: hidden;
}
</style>
<style scoped>
.published-items-container {
  width: 100%;
  padding: 20px;
  overflow-x: hidden;

  display: flex;
  flex-direction: column;
  gap: 1rem
}

.published-items-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.invite-friends-cta {
  width: 100%;
  display: flex;
  justify-content: center;
}

.change-state-page-content .select-state-btn:not([disabled]):hover:before {
  background-color: transparent !important;
}
.change-state-page-content .select-state-btn:hover {
  opacity: 0.5;
}

@media screen and (min-width: 769px) {
  .published-items-container {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 3rem;
  }
  .published-items-content {
    width: 70%;
  }

  .invite-friends-cta {
    width: 30%;
    margin-top: 116px;
    margin-left: 2rem;
    align-self: flex-start;
  }
}

@media screen and (min-width: 1024px) {
  .published-items-container {
    padding: 1rem 5rem;
  }

  .published-items-content {
    width: 80%;
  }

  .invite-friends-cta {
    width: 20%;
    margin-left: 3rem;
  }
}
</style>

<style lang="scss" scoped>
.refer-cta-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
